<template>
    <vue-bottom-sheet ref="myBottomSheet" class="bottom-menu" :swipe-able="false" @click.stop.prevent>
        <div class="bottom-menu__scroll">
            <div class="bottom-menu__title">Выберите комнату</div>
            <div tabindex="-1" class="bottom-menu__scroll-layout">
                <div class="bottom-menu__item main-text" v-for="(location, index) in rooms" :key="index" @click.stop.prevent="updateLocation(index)">
                    <div class="d-inline-flex align-center">
                        <span>{{ location.name }}</span>
                        <div
                            v-if="edit"
                            v-html="require('!html-loader!@/assets/icons/edit_icon.svg')"
                            class="d-inline-flex ml-2 size-24"
                            @click.stop.prevent="openAddHome(location)"
                        />
                        <div
                            v-if="edit"
                            v-html="require('!html-loader!@/assets/icons/close_icon.svg')"
                            class="d-inline-flex size-24"
                            @click.stop.prevent="openDeleteRoom(location)"
                        />
                    </div>
                    <div
                        v-html="require('!html-loader!@/assets/icons/checked_icon.svg')"
                        class="d-inline-flex size-24"
                    />
                </div>
                <v-flex v-if="edit" class="d-flex justify-center my-1" style="min-height: 50px">
                    <v-btn class="btn-dark main-text align-center" @click="openAddHome({})">
                        Добавить новое помещение
                    </v-btn>
                </v-flex>
            </div>
            <ModalMessage
                v-model="openDeleteRoomModal"
                title="Удаление помещения"
                :text="deleteText"
                text-btn="Отменить"
                text-confirm-btn="Удалить"
                show-confirm-btn
                text-center
                @confirm="deleteRoom"
            />
            <ModalAddHome
                v-if="openAddHomeModal"
                v-model="openAddHomeModal"
                :editHome="chosenHome"
                @update="$emit('updateHomeList')"
            />
        </div>
    </vue-bottom-sheet>
</template>

<script>
import VueBottomSheet from "@webzlodimir/vue-bottom-sheet";
import ModalMessage from "@/components/modals/ModalMessage";
import ModalAddHome from "@/components/modals/ModalAddHome";

export default {
    name: "BottomSheetHome",
    components: {
        VueBottomSheet,
        ModalMessage,
        ModalAddHome,
    },
    props: {
        activeGroup: {
            type: Number,
        },
        locations: {
            type: Array,
        },
    },
    data() {
        return {
            openAddHomeModal: false,
            openDeleteRoomModal: false,
            deleteText: "",
            chosenHome: null,
        }
    },
    computed: {
        edit() {
            return this.$store.getters.editMode;
        },
        rooms() {
            return JSON.parse(JSON.stringify(this.locations)).splice(this.offset, this.locations.length);
        },
    },
    methods: {
        open() {
            this.$refs.myBottomSheet.open();
        },
        close() {
            this.$refs.myBottomSheet.close();
        },
        updateLocation(index) {
            this.$emit("setRoom", this.locations[index]);
            this.close();
        },
        openAddHome(location = null) {
            this.chosenHome = location;
            this.openAddHomeModal = true;
        },
        openDeleteRoom(location) {
            this.chosenHome = location.uid;
            this.deleteText = `Вы действительно хотите удалить помещение ${location.name}?`;
            this.openDeleteRoomModal = true;
        },
        deleteRoom() {
            this.$http.delete(`/homes/home/homes/${this.chosenHome}/`)
                .then(() => {
                    this.close();
                    this.$emit("updateHomeList");
                    this.openDeleteRoomModal = false;
                })
                .catch((error) => {
                    console.log(error);
                    this.cancel();
                });
        },
    }
}
</script>

<style lang="scss" scoped>
.bottom-menu {
    &::v-deep .bottom-sheet__card {
        background: var(--rh-list-background);
        bottom: 56px !important;
        padding: 0 0 12px;
        max-height: 70% !important;
    }

    &::v-deep .bottom-sheet__content {
        overflow: unset;
    }

    &__title {
        color: var(--rh-main-color);
        font-size: 18px;
        font-style: normal;
        font-weight: 600;
        line-height: 22px;
        padding: 0 18px 10px;
        position: absolute;
        background: var(--rh-list-background);
        z-index: 10;
    }

    &__scroll {
        overflow-y: scroll;
        height: 100%;
    }

    &__scroll-layout {
        overflow-y: scroll;
        position: relative;

        &::-webkit-scrollbar {
            display: none;
        }
    }

    &__item {
        padding: 10px 18px;
        display: flex;
        justify-content: space-between;

        &:hover {
            cursor: pointer;
            background: var(--rh-button-background);
        }

        &:first-child {
            margin-top: 30px;
        }
    }
}
</style>